export default __webpack_public_path__ + "static/media/Armbands of Quilled Darts.596992ed.jpg";